import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Ce livre électronique est-il vraiment pour les débutants absolus ?',
  a: "Oui. Le Système K-SMART Visuel est conçu pour les personnes qui n'ont jamais étudié le coréen ou toute autre langue. Nous commençons par l'alphabet et construisons tout étape par étape."
}, {
  q: "Puis-je apprendre même si je n'ai pas de bonne base en langues ?",
  a: 'Absolument. Cette méthode n’est pas basée sur la grammaire traditionnelle, mais sur la reconnaissance visuelle des motifs. Votre cerveau est déjà conçu pour cela.'
}, {
  q: 'Les expressions et les phrases sont-elles réellement utiles, ou juste des exemples ?',
  a: 'Elles sont 100% réelles. Chaque phrase apparaît dans des K-Dramas, des chansons ou des conversations authentiques en Corée. Vous apprenez ce que les Coréens utilisent réellement.'
}, {
  q: 'L’ebook inclut-il des conseils de prononciation et des astuces pour éviter les erreurs ?',
  a: "Oui. Le Bonus 3 inclut la méthode pour maîtriser chaque son du coréen grâce à la\nvisualisation articulatoire."
}, {
  q: 'Quand verrai-je un vrai progrès ?',
  a: 'La plupart des étudiants lisent leur première phrase sans erreur au jour 1-2. Au jour 7, vous lisez les menus et les panneaux coréens. Au jour 60, vous comprenez 30-40% des K-Dramas sans sous-titres.'
}, {
  q: 'Ai-je besoin d’autres apps ou puis-je utiliser uniquement ce système ?',
  a: 'Vous pouvez utiliser Coréen Express seul et arriver à la fluidité complète. Les apps supplémentaires (Duolingo, Naver) sont optionnelles pour plus de pratique.'
}, {
  q: 'Et si je n’ai pas 60 minutes chaque jour ?',
  a: 'Le système est flexible. Vous pouvez l’étudier en segments de 10-15 minutes. Même 20 minutes par jour vous amèneront à la fluidité en 30 jours.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Questions fréquemment posées" className="bg-transparent" data-id="element-59" data-mp="n07ynb1uwtj4">
      <div className="mx-auto max-w-3xl px-5 py-12" data-id="element-60" data-mp="2pmdeg7vm9mtx">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-61" data-mp="2pny5vommwpnk">
          ❓ Questions Fréquemment Posées
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-62" data-mp="2fwka9rxt09zp">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-63" data-mp="38l93l4smbb0w" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-64" data-mp="38kg7qyv765xj">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-65" data-mp="2umhww3g34rms">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-66" data-mp="1n8eor2yxegyt" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-67" data-mp="1n5to2had672n" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-68" data-mp="1j8xl8f327twa">
                  <div className="overflow-hidden" data-id="element-69" data-mp="2qnczx5gfwww">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-70" data-mp="7ooyeoqcs8bj">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}